module.exports = __webpack_public_path__ + "static/assets/5c6ee7ea907b1335ebf5b032296efd54.png";